export const isSafiApp = () => navigator.userAgent.includes('SafiApp');
